import React from "react";
import { useSelector } from "react-redux";
import { Navigate, Outlet } from "react-router-dom";
import MainLoader from "../components/sub/MainLoader";

function PositionRoute() {
  const positionState = useSelector((state) => state.positionState.value);
  const userState = useSelector((state) => state.userState.value);
  const setupAccountState = useSelector(
    (state) => state.setupAccountState.value
  );
  if (userState.username) {
    if (setupAccountState) {
      if (positionState) {
        return <Navigate to={"/metabase"} replace />;
      } else {
        return <Outlet />;
      }
    }
  }
  return <MainLoader />;
}

export default PositionRoute;
